/**
 * ConnectionError — полноэкранная заглушка «нет связи с сервером» с кнопкой повтора.
 * Показывается, когда не удалось загрузить данные экрана (напр. /v1/account). onRetry может
 * вернуть промис — на время его выполнения кнопка блокируется и показывает индикатор.
 */
import { useState } from "react";
import { Button } from "@/components/Button";
import { Spinner } from "@/components/Spinner";

export function ConnectionError({ onRetry }: { onRetry: () => void | Promise<void> }) {
  const [loading, setLoading] = useState(false);
  const retry = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await onRetry();
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-surface-base px-8 text-center text-white">
      <div className="mb-5 grid h-16 w-16 place-items-center rounded-full bg-white/[0.06] text-[32px]">📡</div>
      <h1 className="text-[22px] font-semibold">Нет связи с сервером</h1>
      <p className="mt-2 max-w-xs text-[15px] leading-snug text-white/55">
        Не удалось загрузить данные. Проверьте подключение к интернету и попробуйте ещё раз.
      </p>
      <Button className="mt-8 max-w-xs" onClick={retry} disabled={loading}>
        {loading ? <Spinner className="mx-auto h-5 w-5" /> : "Повторить"}
      </Button>
    </div>
  );
}
